<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <Header />
    <!-- <HomeSideMenu/> -->
    <div class="banner-wrap" >
      <Banner class="banner" />
    </div>
    <div class="home" >
      <router-view />
    </div>
    <!-- <div class="cooperation">
      <cooperationList />  
    </div> -->

    <a-back-top />
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import HomeSideMenu from '../components/HomeSideMenu';
import cooperationList from "../components/cooperationList.vue";
export default {
  name: "HomeLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Banner,
    Footer,
    HomeSideMenu,
    cooperationList
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
  },
};
</script>
<style>
  a *{
    transition: all 0.1s ease;
  }
</style>
<style lang="less" scoped>
.container {
  background-image: url('../assets/aice2/page_background.jpg');
  background-size:100% 100% ;
  .cooperation{
    width: 100%;
    margin: 0 auto;
  }
  .banner-wrap {
    .banner-bg{
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: 20px auto;
      max-width: 1200px;
      overflow: hidden;
      border-radius: 0 0 10px 10px;
    }
  }
  .home {
    max-width: 1200px;
    margin: 24px auto;
    // padding: 20px 60px 100px 60px;
    // background: url(../assets/content-bg.png) no-repeat;
    // background-size: 100% 100%;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  // background: url(../assets/bg2.jpg);
  // background: linear-gradient( 120deg, rgba(255,255,255,0) 15%, #afbfff 100%);
}
.mobile {
  .cooperation{
    width: 100% !important;
  }
  .banner-wrap{
    padding: 0 12px;
  }
  .home{
    padding: 0 12px !important;
  }
}
</style>